import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useBreakpoint } from "../../../libs/breakpoint";
import './Drawer.scss';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { DisableBodyScroll } from '../../../hooks/useDisableBodyScroll';

const Drawer = ({
    open = false,
    handleClose,
    children,
    headContent,
    closeBtn = true,
    xsmall, small, large, xlarge,
    overflowEnabled = true,
    unlimitedHeight = false,
    darkMode,
    lockBackgroundClose = false,   // <— NEW : empêche la fermeture via le fond
    lockEscClose = false,          // <— (optionnel) bloque la touche Échap
}) => {
    const breakpoints = useBreakpoint();
    const isMobile = breakpoints.xs || breakpoints.sm;

    // (Optionnel) Empêcher ESC de fermer
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') {
                if (lockEscClose) return;       // ignore ESC si verrouillé
                handleClose?.();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [open, lockEscClose, handleClose]);

    return open ? ReactDOM.createPortal(
        <div className={classNames("drawer", { 'modal-mode': !isMobile, xsmall, small, large, xlarge, 'overflow-enabled': overflowEnabled, 'dark-mode': darkMode, 'unlimited-height': unlimitedHeight })}>
            <DisableBodyScroll />
            <div className="drawer-wrapper" >
                <div className={classNames("drawer-head", { "has-head-contrent": !!headContent })}>
                    {headContent}
                    {(closeBtn && typeof handleClose === 'function') && (
                        <div className="drawer-close-btn" onClick={handleClose}>
                            <FontAwesomeIcon icon={faTimes} />
                        </div>
                    )}
                </div>
                <div className="drawer-content">
                    {children}
                </div>
            </div>
            {/* BACKDROP */}
            <div
                className={classNames("drawer-close", { 'is-disabled': lockBackgroundClose })}
                onClick={lockBackgroundClose ? undefined : (handleClose || (() => { }))}
                aria-hidden="true"
            />
        </div>
        ,
        document.body) : null;
};

export default Drawer;
